import { fetchResourceFormConfig } from "src/system/fetchResourceFormConfig.ts";
import type { FieldValues } from "react-hook-form";
import type { ValidParams } from "src/lib/react-router/types.ts";
import type {
  ValidFormData,
  ValidRequestData,
} from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";

export const resourceFormConfigQuery = <
  FormValues extends FieldValues = FieldValues,
  Params extends ValidParams = ValidParams,
  FormData extends ValidFormData = ValidFormData,
  RequestData extends ValidRequestData = ValidRequestData,
>({
  resource,
  action,
  tab,
}: {
  resource: string;
  action: "edit" | "create";
  tab?: string;
}) => ({
  queryKey: ["formConfig", resource, action, tab ?? "general"],
  queryFn: async () => {
    return await fetchResourceFormConfig<
      FormValues,
      Params,
      FormData,
      RequestData
    >({
      resource,
      action: action,
      tab,
    });
  },
});
